/* Kupi Brzo – lagani JS: lista želja (localStorage), meni drawer, slajder */
(() => {
  const KEY = 'bk_wishlist';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} document.dispatchEvent(new CustomEvent('bk:wishlist', { detail: list })); };

  const paint = () => {
    const list = read();
    document.querySelectorAll('[data-bk-wish-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0 && el.dataset.hideZero !== undefined; });
    document.querySelectorAll('[data-bk-wish]').forEach((btn) => {
      const on = list.includes(btn.dataset.bkWish);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on);
    });
  };

  document.addEventListener('click', (e) => {
    const wish = e.target.closest('[data-bk-wish]');
    if (wish) {
      e.preventDefault();
      const h = wish.dataset.bkWish; let list = read();
      list = list.includes(h) ? list.filter((x) => x !== h) : [...list, h];
      write(list);
      return;
    }
    const open = e.target.closest('[data-bk-drawer-open]');
    if (open) { document.getElementById(open.dataset.bkDrawerOpen)?.showModal(); return; }
    const close = e.target.closest('[data-bk-drawer-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    if (e.target.matches?.('dialog.bk-drawer')) e.target.close();
  });

  document.addEventListener('bk:wishlist', paint);
  document.addEventListener('DOMContentLoaded', paint);
  document.addEventListener('shopify:section:load', paint);
  paint();

  /* Tabovi kategorija */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-bk-tab]');
    if (!tab) return;
    const root = tab.closest('[data-bk-tabs]');
    root.querySelectorAll('[data-bk-tab]').forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    root.querySelectorAll('[data-bk-panel]').forEach((p) => { p.hidden = p.dataset.bkPanel !== tab.dataset.bkTab; });
  });

  /* Hero slajder */
  const initSlider = (root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const slides = [...root.querySelectorAll('.bk-hero__slide')];
    const dots = [...root.querySelectorAll('.bk-hero__dot')];
    if (slides.length < 2) return;
    let i = 0, timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k !== i); });
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const auto = Number(root.dataset.autoplay || 0) * 1000;
    const start = () => { if (auto && !matchMedia('(prefers-reduced-motion: reduce)').matches) { stop(); timer = setInterval(() => go(i + 1), auto); } };
    const stop = () => clearInterval(timer);
    root.querySelector('[data-bk-prev]')?.addEventListener('click', () => { go(i - 1); start(); });
    root.querySelector('[data-bk-next]')?.addEventListener('click', () => { go(i + 1); start(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); start(); }));
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('shopify:block:select', (ev) => { stop(); go(slides.findIndex((s) => s.id === ev.target.id)); });
    go(0); start();
  };
  const boot = () => document.querySelectorAll('[data-bk-slider]').forEach(initSlider);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();

  /* Gornja traka sa porukama */
  const initAnnounce = (root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const msgs = [...root.querySelectorAll('.bk-topbar__msg')];
    if (msgs.length < 2) return;
    let i = 0, timer;
    const go = (n) => { i = (n + msgs.length) % msgs.length; msgs.forEach((m, k) => m.classList.toggle('is-active', k === i)); };
    const auto = Number(root.dataset.autoplay || 0) * 1000;
    const start = () => { clearInterval(timer); if (auto) timer = setInterval(() => go(i + 1), auto); };
    root.querySelector('[data-bk-a-prev]')?.addEventListener('click', () => { go(i - 1); start(); });
    root.querySelector('[data-bk-a-next]')?.addEventListener('click', () => { go(i + 1); start(); });
    root.addEventListener('shopify:block:select', (ev) => { clearInterval(timer); go(msgs.indexOf(ev.target)); });
    start();
  };
  const bootA = () => document.querySelectorAll('[data-bk-announce]').forEach(initAnnounce);
  document.addEventListener('DOMContentLoaded', bootA);
  document.addEventListener('shopify:section:load', bootA);
  bootA();

  /* Iznos korpe u headeru: osvežava se kad se promeni broj artikala */
  const watchCart = () => {
    const box = document.querySelector('[data-bk-cart]');
    const out = document.querySelector('[data-bk-cart-total]');
    if (!box || !out || box.dataset.watch) return; box.dataset.watch = '1';
    const refresh = () => fetch('/cart.js').then((r) => r.json()).then((c) => {
      out.textContent = (c.total_price / 100).toLocaleString('sr-RS', { maximumFractionDigits: 0 }) + ' ' + (c.currency || '');
    }).catch(() => {});
    new MutationObserver(refresh).observe(box, { childList: true, subtree: true, characterData: true, attributes: true });
    document.addEventListener('bk:cart-refresh', refresh);
  };
  document.addEventListener('DOMContentLoaded', watchCart);
  document.addEventListener('shopify:section:load', watchCart);
  watchCart();
  /* Hamburger meni: povuci SVE kolekcije iz prodavnice (/collections.json), ne samo prvih 50 */
  const loadCats = async () => {
    const ul = document.querySelector('[data-bk-cats]');
    if (!ul || ul.dataset.loaded) return; ul.dataset.loaded = '1';
    const ex = (ul.dataset.exclude || '').split(',').filter(Boolean);
    const showCount = ul.dataset.count === 'true', hideEmpty = ul.dataset.hideEmpty === 'true', showImg = ul.dataset.images === 'true';
    const esc = (s) => { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    let all = [];
    try {
      for (let page = 1; page <= 10; page++) {
        const r = await fetch('/collections.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } });
        if (!r.ok) break;
        const data = (await r.json()).collections || [];
        all = all.concat(data);
        if (data.length < 250) break;
      }
    } catch (e) { return; }
    all = all.filter((c) => !ex.includes(c.handle) && !(hideEmpty && c.products_count === 0));
    if (!all.length) return;
    const keys = new Set();
    ul.querySelectorAll(':scope > li[data-keep]').forEach((li) => { if (li.dataset.title) keys.add(li.dataset.title); if (li.dataset.handle) keys.add(li.dataset.handle); });
    ul.querySelectorAll(':scope > li[data-auto]').forEach((li) => li.remove());
    all = all.filter((c) => !keys.has(c.handle) && !keys.has((c.title || '').trim().toLowerCase()));
    all.forEach((c) => {
      const li = document.createElement('li');
      li.innerHTML = '<a href="/collections/' + encodeURIComponent(c.handle) + '">' +
        (showImg ? (c.image && c.image.src ? '<img class="bk-drawer__thumb" src="' + c.image.src + '" width="32" height="32" alt="" loading="lazy">' : '<span class="bk-drawer__thumb bk-drawer__thumb--empty"></span>') : '') +
        '<span class="bk-drawer__name">' + esc(c.title) + '</span>' +
        (showCount ? '<span class="bk-drawer__count">' + c.products_count + '</span>' : '') + '</a>';
      ul.appendChild(li);
    });
  };
  document.addEventListener('DOMContentLoaded', () => (window.requestIdleCallback || setTimeout)(loadCats));
  document.addEventListener('click', (e) => { if (e.target.closest('[data-bk-drawer-open]')) loadCats(); });
  document.addEventListener('shopify:section:load', loadCats);
  /* Link iz hamburger menija (#kat-naziv) otvara odgovarajucu karticu kategorije */
  const openTabFromHash = () => {
    const m = location.hash.match(/^#kat-(.+)$/); if (!m) return;
    const tab = document.querySelector('[data-bk-slug="' + decodeURIComponent(m[1]) + '"]'); if (!tab) return;
    tab.click();
    const dlg = document.querySelector('dialog.bk-drawer'); if (dlg && dlg.open) dlg.close();
    const box = document.getElementById('kategorije'); if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  window.addEventListener('hashchange', openTabFromHash);
  document.addEventListener('DOMContentLoaded', openTabFromHash);
})();
